import React, {useEffect, useState} from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { TextInput } from 'Ficha/components/TextInput'
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import LeeLink from 'Ficha/pdf/leeLink'
import EvalTable from 'Ficha/components/evaluations/EvalTable'
import { atualizarLee } from 'firebase/firestoreData'

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "12px",
    textAlign: "justify",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  field:{
    margin: '10px auto',
  },
  tableBox:{
    padding: 10,
  },
  formControl:{
    margin: 20,
  },
  miniTable:{
    maxWidth: 360,
    margin: '0 auto'
  },
  miniTableRow:{
    height: 42,
  },
  deleteButton:{
    margin: 20,
    border: '1px solid blue',
    color: 'blue'
  },
  heading:{
    marginLeft: 10,
  },
  buttons:{
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: 30,
  },
  btn:{
    width: 80,
  },
  table:{
    width: '90%',
    margin: '30px auto'
  },
  texts: {
    margin: '0 auto',
    backgroundColor: 'rgb(240, 240, 240)',
    borderRadius: 8,
    maxWidth: '600px',
    padding: 8,
    paddingLeft: 15,
    textAlign: 'justify',
    boxShadow: '2px 2px 7px black'
  }
};

const useStyles = makeStyles(styles);

export default function Lee(props) {
  const classes = useStyles();
  const ficha  = props.location.state
  const history = useHistory();
  const [showBtn, setShowBtn] = useState(false)
  const [riskSum, setRiskSum] = useState(0)
  const [riskText, setRiskText] = useState("")
  const [riskArray, setRiskArray] = useState([0, 0, 0, 0, 0, 0])

  useEffect(() => {
  const timer = setTimeout(() => {
    setShowBtn(true)
  }, 1000);
  return () => clearTimeout(timer);
}, []);

  useEffect(() => {
    if (ficha.lee){
      setRiskArray(ficha.lee)
      updateRisk(ficha.lee)
    } else {
      setRiskArray([0, (ficha.coronariopatia || ficha.iam) ? 1:0, ficha.icc ? 1:0, ficha.avc ? 1:0, 0, Number(ficha.creat)>2 ? 1:0])
      updateRisk([0, (ficha.coronariopatia || ficha.iam) ? 1:0, ficha.icc ? 1:0, ficha.avc ? 1:0, 0, Number(ficha.creat)>2 ? 1:0])
    }
  }, [ficha.lee, ficha.creat, ficha.coronariopatia, ficha.icc, ficha.avc, ficha.iam]);

  useEffect(()=>{
    let text = ""
    if (riskSum === 0) {
        text = <p>Não foi identificada <b>nenhuma </b>variável de Lee<br/>
          => Nesse caso, o risco de complicações cardíacas maiores é de <b>0,4%</b><br/>
          Complicações cardíacas maiores incluem: infarto do miocárdio, edema
          pulmonar, fibrilação ventricular ou parada cardíaca primária, e bloqueio
          cardíaco completo até o 5o dia pós-operatório.</p>
        }
    if (riskSum === 1) {
        text = <p>Foi identificada <b>1 </b>variável de Lee<br/>
          =>Nesse caso, o risco de complicações cardíacas maiores é de <b>0,9%</b><br/>
          Complicações cardíacas maiores incluem: infarto do miocárdio, edema
          pulmonar, fibrilação ventricular ou parada cardíaca primária, e bloqueio
          cardíaco completo até o 5o dia pós-operatório.</p>
        }
    if (riskSum === 2) {
        text = <p>Foram identificadas <b>2 </b>variáveis de Lee<br/>
          =>Nesse caso, o risco de complicações cardíacas maiores é de <b>6,6%</b><br/>
          Complicações cardíacas maiores incluem: infarto do miocárdio, edema
          pulmonar, fibrilação ventricular ou parada cardíaca primária, e bloqueio
          cardíaco completo até o 5o dia pós-operatório.</p>
        }
    if (riskSum > 2) {
        text = <p>Foram identificadas <b>3 ou mais </b>variáveis de Lee<br/>
          =>Nesse caso, o risco de complicações cardíacas maiores é de <b>11%</b><br/>
          Complicações cardíacas maiores incluem: infarto do miocárdio, edema
          pulmonar, fibrilação ventricular ou parada cardíaca primária, e bloqueio
          cardíaco completo até o 5o dia pós-operatório.</p>
    }
    setRiskText(text)
  },[riskSum])

  let genText = <p><u>Sobre o IRCR de Lee:</u><br/>
  - O IRCR foi proposto por Lee et al., em 1999, em um estudo realizado na Califórnia, EUA.
  Este escore compreende uma revisão do Índice proposto por Goldman em 1977.
  No IRCR, os pacientes são divididos em quatro classes de risco, compostas a partir de
  seis variáveis: cirurgia de alto risco, história de doença isquêmica cardíaca,
  história de insuficiência cardíaca congestiva, história de doença cerebrovascular,
  diabetes insulino-dependente e creatinina sérica >2,0mg/dL. As classes I, II, III e IV
  são divididas a partir da somatória dessas variáveis apresentadas pelo paciente,
  totalizando 0, 1, 2 ou ≥ 3, respectivamente. Esta nova revisão foi derivada e validada
  a partir de uma investigação prospectiva com 4315 pacientes, a qual demonstrou que
  este é um índice simples, de fácil aplicação e com boa capacidade para predição
  do risco de complicações cardíacas em cirurgia não cardíaca eletiva de grande porte,
  sobretudo quando comparado com outros índices.</p>

  function updateRisk(riskArray) {
    setRiskArray(riskArray)
  }

  function calcRisk(riskArray) {
    let sum = 0
    for (let i = 0; i < riskArray.length; i++){
      sum = sum + riskArray[i]
    }
    setRiskSum(sum)
  }

  function saveRiskToDB() {
    atualizarLee(ficha.id, riskArray)
  }

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="primary">
              <h4 className={classes.cardTitleWhite}>
                Índice de Risco Cardíaco Revisado de Lee (IRCR)
              </h4>
              <p className={classes.cardCategoryWhite}>
                Todas as informações têm caráter apenas informativo.
                As condutas médicas devem ser decididas pelo médico assistente
                junto com o paciente, respeitando os quatro princípios bioéticos
                fundamentais: autonomia, beneficência, não-maleficência e justiça.
              </p>
              <p className={classes.cardCategoryWhite}>
              Fontes:
              - Lee TH et al. Derivation and prospective validation of a simple index for prediction of cardiac risk of major noncardiac surgery. Circulation. 1999
              - Loureiro B. Perioperative risk scores for non-cardiac surgery: descriptions and comparisons. 2014
              - Gualandro DM et al. 3a Diretriz de Avaliação Cardiovascular Perioperatória da Sociedade Brasileira de Cardiologia. 2017
              </p>
            </CardHeader>
            <CardBody>
            <form>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Nome Completo"
                    name="nomeCompleto"
                    disabled
                    value={ficha.nome}
                  />
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                  <TextInput
                    className={classes.field}
                    label="Procedimento(s)"
                    name="procedimento"
                    multiline
                    disabled
                    value={ficha.procedimentos}
                  />
                </GridItem>
                <div className={classes.table}>
                  <EvalTable onCalcRisk={calcRisk}
                             onUpdateRisk={updateRisk}
                             rows={[['Operação intraperitoneal, intratorácica ou vascular suprainguinal?', 1],
                                   ['História de doença arterial coronariana?', 1],
                                   ['História de insuficiência cardíaca?', 1],
                                   ['História de doença cerebrovascular?', 1],
                                   ['Diabetes Mellitus com insulinoterapia?', 1],
                                   ['Creatinina pré-operatória > 2,0mg/dL?', 1]]}
                              initialValues={riskArray}/>
                </div>
              </GridContainer>
              </form>
              <div className={classes.texts}>
              {riskText}
              {genText}
              </div>
              <div className={classes.buttons}>
              { showBtn && <div>
                <LeeLink ficha={ficha}
                           risk={{risk: riskSum}}
                           link={<Button className={classes.btn} onClick={saveRiskToDB} color="primary">IMPRIMIR</Button>}
                />
              </div>
              }
              <Button className={classes.btn} onClick={()=>{saveRiskToDB(); history.goBack()}} color="primary">VOLTAR</Button>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}
